import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Spinner from './Spinner';

const DefaultButton = props => {
  const {
    className,
    disabled,
    hasFullWidth,
    hasSpinner,
    leftLabel,
    onClick,
    rightLabel,
    spinnerColor,
  } = props;

  const _renderLabel = label => {
    if (React.isValidElement(label)) {
      return label;
    }
    return <span>{label}</span>;
  };

  return (
    <button
      className={classNames('btn-default', className, {
        'full-width': hasFullWidth,
        disabled: disabled,
      })}
      disabled={disabled}
      onClick={onClick ? onClick : null}
    >
      <div
        className={classNames('btn-default-content', {
          'center-left-label': !rightLabel && !hasSpinner,
        })}
      >
        <div>{_renderLabel(leftLabel)}</div>
        {(rightLabel || hasSpinner) && (
          <div className="btn-right-label-container">
            {!hasSpinner && _renderLabel(rightLabel)}
            {hasSpinner && <Spinner className={className} color={spinnerColor} size="20px" />}
          </div>
        )}
      </div>
    </button>
  );
};

DefaultButton.defaultProps = {
  hasSpinner: false,
  hasFullWidth: false,
  disabled: false,
};

DefaultButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  hasSpinner: PropTypes.bool,
  hasFullWidth: PropTypes.bool,
  leftLabel: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  rightLabel: PropTypes.node,
  spinnerColor: PropTypes.string,
};

/****************************************************************************************

                                        Primary Button

*****************************************************************************************/

export const PrimaryButton = props => {
  return (
    <DefaultButton {...props} className={classNames('primary-new', props.className)} />
  );
};

PrimaryButton.propTypes = {
  className: PropTypes.string,
};

/****************************************************************************************

                                        Secondary Button

*****************************************************************************************/

export const SecondaryButton = props => {
  return (
    <DefaultButton {...props} className={classNames('secondary-new', props.className)} />
  );
};

SecondaryButton.propTypes = {
  className: PropTypes.string,
};

/****************************************************************************************

                                          Text Button

*****************************************************************************************/

export const TextButton = props => {
  return (
    <DefaultButton {...props} className={classNames('primary-text-new', props.className)} />
  );
};

TextButton.propTypes = {
  className: PropTypes.string,
};

/****************************************************************************************

                                    PayPal Express Button

*****************************************************************************************/

export const PayPalExpressButton = props => {
  return (
    <DefaultButton {...props} className={classNames('paypal-express', props.className)} />
  );
};

PayPalExpressButton.propTypes = {
  className: PropTypes.string,
};
